module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/intro-1.jpg"
    }
  })])]), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/11_foreword#for",
      "id": "for"
    }
  }, [_vm._v("Foreword by the Colonel of the Regiment")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/12_acknowledgements#ack",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/13_introduction#intro",
      "id": "intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('em', [_vm._v("Chapter")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#ch1",
      "id": "ch1"
    }
  }, [_vm._v("  1.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/15_chapter_1#ch1"
    }
  }, [_vm._v("The Early Years")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ch2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great War")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between The Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 1/6th and 4/6th in Burma")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chindits")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_chapter_6#ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#ch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emergency in Malaya")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Confrontation in Borneo")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ch9",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Hawk’ and Amalgamation")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_chapter_10#ch10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Great and the Good’")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#ch11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Johnny Gurkha’")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ch12",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/26_chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Twelve Years: 1982–1994")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/27_chapter_13#ch13",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/27_chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 175th Anniversay")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_epilogue#epi",
      "id": "epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1",
    staticStyle: {
      "margin-top": ".8em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/29_glossary#glo",
      "id": "glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/30_app_1#app1",
      "id": "app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I – The Victoria Cross")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/31_app_2#app2",
      "id": "app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II – Colonels of the Regiment 1904–1994")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/32_app_3#app3",
      "id": "app3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix III – Commanding Officers")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/33_app_4#app4",
      "id": "app4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV – Gurkha Majors 1948–1994")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/34_app_5#app5",
      "id": "app5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix V – A Jungle Patrol")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "list-item1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/35_app_6#app6",
      "id": "app6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VI – The Royal Gurkha Rifles")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/36_bibliography#bib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/37_index#ind",
      "id": "toc-ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f65101","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/08_contents.vue
// module id = 75
// module chunks = 0